import httpClient, { GET } from 'providers/http'

export function fetchLanguages ({ signal }) {
  return httpClient({
    endpoint: '/api/v1/languages',
    method: GET,
    requiresAuth: true,
    signal
  })
}